import axios from "axios";
import toast from "react-hot-toast";

export const s3Upload = async (img) => {
  if (!img) {
    toast.error("No file Provided!");
    throw new Error("No file Provided!");
  }
  const imageForm = new FormData();
  imageForm.append("image", img);

  try {
    const s3Response = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/file/add`,
      imageForm,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );

    if (!s3Response || s3Response.status !== 200) {
      toast.error("File Upload Failed");
      throw new Error("File Upload Failed");
    }

    return s3Response.data.data.location;
  } catch (error) {
    toast.error("File Upload Failed");
    throw error;
  }
};

export const splitFileIntoChunks = (file) => {
  const CHUNK_SIZE = 5 * 1024 * 1024; // 5MB
  const chunks = [];
  let start = 0;
  while (start < file.size) {
    const end = Math.min(start + CHUNK_SIZE, file.size);
    chunks.push(file.slice(start, end));
    start = end;
  }
  return chunks;
};

export const s3MultipartUploadStart = async (key) => {
  if (!key) {
    toast.error("No file key Provided!");
    throw new Error("No file key Provided!");
  }

  try {
    const { data } = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/file/start-multipart-upload`, {
      key,
    });

    if (!data || data.statusCode !== 200) {
      toast.error("File Upload Failed");
      throw new Error("File Upload Failed");
    }
    return data;
  } catch (error) {
    toast.error("File Upload Failed");
    throw error;
  }
};

export const generatePreSignedUrls = async (key, uploadId, chunkCount) => {
  if (!key || !uploadId || !chunkCount) {
    toast.error("Missing required parameters!");
    throw new Error("Missing required parameters!");
  }

  try {
    const { data } = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/file/generate-presigned-url`, {
      key,
      uploadId,
      chunkCount,
    });

    if (!data || data.statusCode !== 200) {
      toast.error("Failed to generate pre-signed URLs");
      throw new Error("Failed to generate pre-signed URLs");
    }
    return data;
  } catch (error) {
    toast.error("Failed to generate pre-signed URLs");
    throw error;
  }
};

export const completeMultipartUpload = async (key, uploadId, parts) => {
  if (!key || !uploadId || !parts) {
    toast.error("Missing required parameters!");
    throw new Error("Missing required parameters!");
  }

  try {
    const { data } = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/file/complete-multipart-upload`, {
      key,
      uploadId,
      parts,
    });

    if (!data || data.statusCode !== 200) {
      toast.error("Failed to complete multipart upload");
      throw new Error("Failed to complete multipart upload");
    }
    return data;
  } catch (error) {
    toast.error("Failed to complete multipart upload");
    throw error;
  }
};